// require ('promise-polyfill');
import 'promise-polyfill';
import 'whatwg-fetch';
import EnableTabbing from './modules/EnableTabbing';
import FilterSwiper from './modules/FilterSwiper';
import EventFilter from './modules/EventFilter';
import OldBrowser from './modules/OldBrowser';

EnableTabbing();
EventFilter();
FilterSwiper();
OldBrowser();


document.addEventListener('DOMContentLoaded', () => {
    if (!('ontouchstart' in document.documentElement)) {
        document.body.classList.add('no-touch');
    }
});
